import Octicon from "react-octicon";
import { Link } from "react-router-dom";
import React from "react";

export const ReportingPackageStatusItem = ({
  projectId,
  index,
  color,
  refId,
  refName,
  commitId,
  status,
  dates,
  depth,
}) => {
  if (!projectId) {
    return null;
  }

  let hideDates = status == "Requires Revision" || status == "Pending Approval";

  return (
    <React.Fragment>
      <div
        key={index}
        className="d-flex align-items-center py-2 px-2 hover-row border-bottom border-light"
        style={{ paddingLeft: `${depth}em`, minHeight: "48px" }}
      >
        <div className="flex-grow-1 pr-2">
          <RefName projectId={projectId} refId={refId} refName={refName} />
        </div>
        <div className="flex-shrink-0 px-2" style={{ width: "180px" }}>
          <Status status={status} dates={dates} />
        </div>
        <div className="flex-shrink-0 px-2 text-muted small" style={{ width: "140px" }}>
          {!hideDates && <Dates dates={dates} />}
        </div>
        <div className="flex-shrink-0 pl-2">
          <GoToReport projectId={projectId} refId={refId} commitId={commitId} />
        </div>
      </div>
    </React.Fragment>
  );
};

const RefName = ({ projectId, refId, refName }) => {
  projectId = projectId ? projectId.substring(0, 8) : projectId;
  refId = refId ? refId.substring(0, 8) : refId;
  return (
    <div className="d-flex align-items-center">
      <Octicon name="file" className="text-muted mr-1 flex-shrink-0" />
      <Link
        className="text-decoration-none text-dark font-weight-medium"
        to={`/project/${projectId}/wpack/${refId}/report`}
      >
        {refName}
      </Link>
    </div>
  );
};

export const Status = ({ status, dates = "" }) => {
  let badgeColor = "warning";
  if (status === "Overdue" || dates?.includes("overdue")) {
    status = "Overdue";
    badgeColor = "danger";
  } else if (status === "Requires Revision") {
    badgeColor = "mild-warning";
  } else if (status === "OK for Submission") {
    badgeColor = "success";
    status = "Approved";
  } else if (status === "Pending Review") {
    badgeColor = "info";
    status = "Pending Data Control";
  } else if (status === "Pending Input") {
    badgeColor = "primary";
  } else if (status === "Nothing Received") {
    badgeColor = "secondary";
  }

  return (
    <h6 className="mb-0">
      <span className={`badge rounded-pill badge-${badgeColor} px-2 py-1`}>{status}</span>
    </h6>
  );
};

const Dates = ({ dates, hide }) => {
  return <div>{hide ? "" : dates}</div>;
};

const GoToReport = ({ projectId, refId, commitId }) => {
  projectId = projectId ? projectId.substring(0, 8) : projectId;
  refId = refId ? refId.substring(0, 8) : refId;
  commitId = commitId ? commitId.substring(0, 8) : commitId;
  return (
    <Link
      className="btn btn-sm btn-outline-primary"
      to={`/project/${projectId}/wpack/${refId}/report/${commitId ? commitId : ""}`}
    >
      View
    </Link>
  );
};
